module.exports = __webpack_public_path__ + "img/event-ic-bg-slogan-title.8eab3e07.png";